<template>
  <div>
    <validation-observer ref="observer">
      <div v-if="nonFieldErrors.length" class="column is-12">
        <vue-form-errors :non-field-errors="nonFieldErrors"></vue-form-errors>
      </div>
      <div class="columns is-multiline is-size-7">
        <div class="column is-6 is-12-mobile">
          <div>
            <validation-provider
              v-slot="{ errors }"
              :name="$t('fullName')"
              rules="required"
            >
              <div class="field">
                <label class="label is-size-6 has-text-grey">
                  <vue-icon-base
                    height="16"
                    width="16"
                    :path="$options.icons[$kc('uni-user-circle')]"
                  >
                  </vue-icon-base>
                  {{ $t('fullName') }}
                  <span class="has-text-danger">*</span>
                </label>
                <div class="control">
                  <input
                    v-model="formValues.full_name"
                    :class="{
                      'is-danger': errors.length || fieldErrors.full_name
                    }"
                    class="input"
                    type="text"
                    :placeholder="$t('fullName')"
                    @keyup.enter="signup"
                  />
                </div>
                <p class="field-error help is-danger">
                  {{ errors[0] || fieldErrors.full_name }}
                </p>
              </div>
            </validation-provider>
          </div>
          <div>
            <validation-provider
              v-slot="{ errors }"
              :name="$t('Phone')"
              rules="required|digits:10|integer"
            >
              <div class="field">
                <label class="label is-size-6 has-text-grey">
                  <vue-icon-base
                    height="16"
                    width="16"
                    :path="$options.icons[$kc('uni-phone')]"
                  >
                  </vue-icon-base>
                  {{ $t('Phone') }}
                  <span class="has-text-danger">*</span>
                </label>
                <div class="control">
                  <input
                    v-model="formValues.phone_number"
                    :class="{
                      'is-danger': errors.length || fieldErrors.phone_number
                    }"
                    class="input"
                    type="text"
                    :placeholder="$t('Phone')"
                    @keyup.enter="signup"
                  />
                </div>
                <p class="field-error help is-danger">
                  {{ errors[0] || fieldErrors.phone_number }}
                </p>
              </div>
            </validation-provider>
          </div>
          <div>
            <validation-provider v-slot="{ errors }" :name="$t('Email')">
              <div class="field">
                <label class="label is-size-6 has-text-grey">
                  <vue-icon-base
                    height="16"
                    width="16"
                    :path="$options.icons[$kc('uniEnvelope')]"
                  >
                  </vue-icon-base>
                  {{ $t('Email') }}
                </label>
                <div class="control">
                  <input
                    v-model="formValues.email"
                    :class="{
                      'is-danger': errors.length || fieldErrors.email
                    }"
                    class="input"
                    type="text"
                    :placeholder="$t('Email')"
                    @keyup.enter="signup"
                  />
                </div>
                <p class="field-error help is-danger">
                  {{ errors[0] || fieldErrors.email }}
                </p>
              </div>
            </validation-provider>
          </div>
        </div>
        <div class="column is-6">
          <div>
            <validation-provider v-slot="{ errors }" :name="$t('Description')">
              <div class="field">
                <label class="label is-size-6 has-text-grey">
                  <vue-icon-base
                    height="16"
                    width="16"
                    :path="$options.icons[$kc('uniInfoCircle')]"
                  >
                  </vue-icon-base>
                  {{ $t('Description') }}
                </label>
                <div class="control">
                  <textarea
                    v-model="formValues.description"
                    rows="8"
                    :class="{
                      'is-danger':
                        errors.length || get(fieldErrors, 'description')
                    }"
                    class="textarea pb-7"
                    :placeholder="$t('Description')"
                  ></textarea>
                </div>
                <p class="field-error help is-danger">
                  {{ errors[0] || fieldErrors.description }}
                </p>
              </div>
            </validation-provider>
          </div>
        </div>
        <div class="column has-text-right is-12">
          <button
            :class="loading ? 'is-loading' : ''"
            class="button is-success"
            @click="submitDetails()"
            v-text="$t('Submit Details')"
          ></button>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import FormMixin from '@/mixins/veeValidate'
import VueIconBase from '@/components/Commons/VueIconBase'
import {
  uniUserCircle,
  uniMapMarker,
  uniListUiAlt,
  uniEnvelope,
  uniPhone,
  uniInfoCircle
} from '@/helpers/icons'
export default {
  icons: {
    uniUserCircle,
    uniMapMarker,
    uniListUiAlt,
    uniEnvelope,
    uniPhone,
    uniInfoCircle
  },
  components: { VueIconBase },
  mixins: [FormMixin],
  props: {
    employer: {
      type: Boolean,
      default: false
    },
    training: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      formValues: {
        full_name: '',
        phone_number: '',
        email: ''
      },
      loading: false
    }
  },
  mounted() {
    if (this.$auth.loggedIn && this.$auth.user.jobseeker_profile) {
      this.formValues.full_name = this.$auth.user.full_name || ''
      this.formValues.phone_number = this.$auth.user.phone_number || ''
      this.formValues.email = this.$auth.user.email || ''
    }
  },
  methods: {
    async submitDetails() {
      this.formValues.training = this.training.title
      if (await this.validateAllFields()) {
        this.loading = true
        const endpoint = `/api/v1/training/${this.training.slug}/send-mail/`
        this.$axios
          .$post(endpoint, this.formValues)
          .then(response => {
            this.notifyUser(
              this.$t(
                'Your details have been submitted. We will contact you soon.'
              )
            )
            this.$router.push(this.localePath({ name: 'training' }))
          })
          .catch(error => {
            this.getError(error)
            if (this.nonFieldErrors.length) {
              const error = this.nonFieldErrors[0]['non field errors'].message
              this.notifyError(error)
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
}
</script>
